module.exports = __webpack_public_path__ + "assets/img/1_img3.c7fe36fc.png";